<template>
  <WdsText class="tw-mb-4">{{ $t('What VAT (BTW) rate applies to your services?') }}</WdsText>

  <WdsRadioGroup v-model:checked="internalModelValue" :name="name">
    <WdsRadio value="nl_standard" :disabled="disabled">
      <WdsStack>
        <WdsText
          :text="$t('Standard Rate (21%)')"
          :sub-text="$t('Most common for consultants, developers, and designers')"
        />
        <WdsTooltip
          :text="$t('Standard for most services (IT, Consulting, Marketing, Engineering).')"
        >
          <WdsIcon :name="WdsIconNameEnum.HELP" size="16" />
        </WdsTooltip>
      </WdsStack>
    </WdsRadio>
    <WdsRadio value="nl_reduced" :disabled="disabled">
      <WdsStack>
        <WdsText
          :text="$t('Reduced Rate (9%)')"
          :sub-text="$t('Only for specific sectors such as journalism or performing arts')"
        />
        <WdsTooltip
          :text="
            $t(
              'Only for specific sectors: Books, Journalism, Performing Arts, and specific Home Maintenance.',
            )
          "
        >
          <WdsIcon :name="WdsIconNameEnum.HELP" size="16" />
        </WdsTooltip>
      </WdsStack>
    </WdsRadio>
    <WdsRadio value="nl_exempt" :disabled="disabled">
      <WdsStack>
        <WdsText
          :text="$t('VAT Exempt (Vrijgesteld)')"
          :sub-text="$t('Healthcare, certain education, and social work professionals')"
        />
        <WdsTooltip
          :text="
            $t(
              'For registered Healthcare, Education, and Financial services. You cannot reclaim input VAT.',
            )
          "
        >
          <WdsIcon :name="WdsIconNameEnum.HELP" size="16" />
        </WdsTooltip>
      </WdsStack>
    </WdsRadio>
    <WdsRadio value="nl_kor" :disabled="disabled">
      <WdsStack>
        <WdsText
          :text="$t('Small Business Scheme (KOR)')"
          :sub-text="$t('I have an official KOR exemption and do not charge VAT')"
        />
        <WdsTooltip
          :text="
            $t(
              'For freelancers with <€20k annual turnover who have officially registered for this scheme.',
            )
          "
        >
          <WdsIcon :name="WdsIconNameEnum.HELP" size="16" />
        </WdsTooltip>
      </WdsStack>
    </WdsRadio>
  </WdsRadioGroup>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import {
  WdsIcon,
  WdsIconNameEnum,
  WdsRadio,
  WdsRadioGroup,
  WdsStack,
  WdsText,
  WdsTooltip,
} from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const internalModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
